<template>
  <div id="addBadge" class="tab-pane" role="tabpanel">
    <!-- .title -->
    <b-row>
      <b-col lg="12">
        <b-form-group
          id="input-group-1"
          :label="$t('assessments.title')"
          label-for="input-1"
        >
          <b-form-input
            id="input-1"
            v-model="newItem.title"
            type="text"
            :placeholder="$t('assessments.title')"
          />
        </b-form-group>
        <!-- .start_date -->
      </b-col>
    </b-row>
    <hr />
    <b-row>
      <b-col lg="4"  v-if="user.account_type == 'admin'">
        <div class="form-group">
          <label>{{ $t("edu_programs.edu_programs") }}</label>

          <b-form-select
            :options="EduPrograms"
            text-field="name"
            value-field="id"
            v-model="newItem.edu_program_id"
            @change="changeEduPrograms(newItem.edu_program_id)"
          />
        </div>
      </b-col>
      <b-col lg="4">
        <b-form-group
          id="input-group-8"
          :label="$t('edu_courses.edu_course')"
          label-for="input-8"
        >
          <b-form-select
            v-model="newItem.edu_course_id"
            :options="edu_course"
            value-field="id"
            text-field="name"
          />
        </b-form-group>
        <!-- .room -->
      </b-col>
      <b-col lg="4"  v-if="user.account_type == 'admin'">
        <b-form-group
          id="input-group-29"
          :label="$t('rooms.rooms')"
          label-for="input-29"
        >
          <b-form-select
            v-model="newItem.room_id"
            :options="rooms"
            text-field="room.name"
            value-field="room.id"
          />
        </b-form-group>
        <!-- .room -->
      </b-col>
    </b-row>
    <hr />
    <b-row>
      <b-col lg="6">
        <b-form-group
          id="input-group-4"
          :label="$t('assessments.degree')"
          label-for="input-4"
        >
          <b-form-input
            id="input-4"
            v-model="newItem.degree"
            type="number"
            :placeholder="$t('assessments.degree')"
          />
        </b-form-group>
        <!-- .type -->
      </b-col>

      <b-col lg="6">
        <b-form-group
          id="input-group-2"
          label="خلال الفترة الزمنية"
          label-for="input-2"
        >
          <flat-pickr
            v-model="rangeDate"
            class="form-control"
            :config="config"
          />
        </b-form-group>
        <!-- .end_date -->
      </b-col>
    </b-row>
    <hr />
    <b-row>
      <b-col lg="12">
        <iframe
          ref="myIframe"
          :src="link"
          frameborder="0"
          style="width: 100%; height: 900px"
        ></iframe>
      </b-col>
    </b-row>
    <hr />
    <b-row>
      <b-col lg="6">
        <b-btn variant="primary" block @click="submit()"  >
          <i class="fa fa-plus" /> {{ $t("site.save") }}</b-btn
        >
      </b-col>
      <b-col lg="6">
        <b-btn variant="success" block>
          <i class="fas fa-ban"></i> {{ $t("site.cancel") }}</b-btn
        >
      </b-col>
    </b-row>
  </div>
</template>

<script>
import controller from "../../../../Controllers/AssessmentsController";
import flatPickr from "vue-flatpickr-component";
import { Arabic } from "flatpickr/dist/l10n/ar.js";
import config from "@/config/config";
import EduProgramsController from "@/Controllers/EduProgramsController";
import Auth from "@/Apis/Auth";
import Edu_schemesController from "@/Controllers/Edu_schemesController";
var dates = [];
export default {
  name: "AssessmentsForm",
  components: {
    flatPickr,
  },
  props: ["newItem"],
  data() {
    return {
      file: {},
      iframeWin: {},
      edu_course: [],
      room: [],
      link: config.serverUrl + "/editor",
      rangeDate: "",
      
      config: {
        mode: "range",
        minDate: "today",
        dateFormat: "Y-m-d",
        locale: Arabic,

        onChange: function (date) {
          if (date.length == 2) {
            dates = date;
            // interact with selected dates here
          }
        },
      },
      EduPrograms: [],
      rooms: [],

      user: Auth.USER,
    };
  },
  mounted() {
    window.addEventListener("message", this.handleMessage);
    this.iframeWin = this.$refs.myIframe.contentWindow;
  },
  async created() {
    if (this.user.account_type == "teacher") {
      const data = await new EduProgramsController().getCourseByProgram();
      this.edu_course = data.filter((a) => a.flixable == 0);
    } else {
      this.EduPrograms = await new EduProgramsController().GetAll({
        with: ["rooms"],
      });
    }
  },
  methods: {
    async    goToTable() {
      this.$parent.$parent.$children[0].$children[0].$refs.table.refresh();
      this.$parent.$parent.firstTab();
    },
    async submit() {
      var dd = new Date();
      if (this.user.account_type == "teacher") {
        this.newItem.edu_program_id = localStorage.getItem("eduProgram");
        this.newItem.room_id = localStorage.getItem("room");
      }
      this.newItem.start_date = dates[0].toJSON().slice(0, 19).replace("T", " ");
      this.newItem.end_date = dates[1].toJSON().slice(0, 19).replace("T", " ");

      let ret = await new controller().From(this.newItem);
      if (ret) {
        this.$parent.$parent.$children[0].$children[0].$refs.table.refresh();
        this.$parent.$parent.firstTab();
      }
    },
    async changeEduPrograms(eduProgram) {
      let data = await new Edu_schemesController().getCourse(eduProgram);
      this.rooms = data.rooms;

      this.edu_course = data.courses;
      // this.courses = this.courses.filter((a) => a.flixable == 0);
      //
    },
    send() {
      this.iframeWin.postMessage(
        {
          cmd: "submit",
          params: {},
        },
        "*"
      );
    },
    handleMessage(event) {
      if (event.data.cmd) {
        this.newItem.h5p = event.data.params.contentId;
      }
    },
  },
  watch: {
    newItem() {
      if (this.newItem.id) {
        this.link = `${config.serverUrl}/h5p-content/${this.newItem.h5p}/edit`;
      }
    },
  },
};
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-flatpicker.scss";
</style>
  